import { createRoot } from 'react-dom/client';
import { store } from "@/stores/dataStore/reduxStore/store";
import { Provider } from 'react-redux';
import MainApp from "./MainApp";

let root: any = null

export default function MainShare(props: any) {
    console.log('remoteApp_log::MainShare', props);
    return (
        <Provider store={store}>
            <MainApp {...props} />
        </Provider>
    );
}

export const mountComponentMicroApp = (container: any, props: any) => {
    root = createRoot(container)
    return root.render(
        // <StrictMode>
        <MainShare {...props} />
        // </StrictMode>,
    )
}

export const unmountComponentMicroApp = (container: any) => {
    return root && root.unmount()
}